module.exports = __webpack_public_path__ + "static/top3-logo-dd803b6af4a722b59ae52ef83b77f481.svg";